/**
 * GLX-1424: the fixed set Solutions reports churn against. The picked label is
 * sent as `reasonToArchive`, the column the Teams table ("Reason" / details row)
 * and the team About card already render as "Reason to Archive".
 */
export const DEACTIVATION_REASONS = [
  'Adoption & Value',
  'Feature / Functionality',
  'Financial',
  'Integration',
  'Organizational Dynamics',
  'Test Team',
  'Other',
] as const;

export type DeactivationReason = (typeof DEACTIVATION_REASONS)[number];
